import { render } from "./LoginCredentials.vue?vue&type=template&id=118ee38f&scoped=true"
import script from "./LoginCredentials.vue?vue&type=script&lang=js"
export * from "./LoginCredentials.vue?vue&type=script&lang=js"

import "./LoginCredentials.vue?vue&type=style&index=0&id=118ee38f&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-118ee38f"]])

export default __exports__